import { render, staticRenderFns } from "./AddTitle.vue?vue&type=template&id=6184a8a1&scoped=true"
import script from "./AddTitle.vue?vue&type=script&lang=js"
export * from "./AddTitle.vue?vue&type=script&lang=js"
import style0 from "./AddTitle.vue?vue&type=style&index=0&id=6184a8a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6184a8a1",
  null
  
)

export default component.exports